module.exports = __webpack_public_path__ + "static/media/body-services.52329d72.jpg";